import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { UpgradeBottomSlides } from 'ThreeTerminal_mobile';
import styles from './index.css';

const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;

class FixBottom extends React.PureComponent {
    render() {
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725215087',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7640',
              };
        const slidesConfig = {
            isVideoShare,
            apiConfig: {
                type: 'all',
                n: '3',
                proid: 'ifeng_share',
                title: document.title,
                id: document.title,
                from: 'share_relate_foot_tfhoursmodel',
            },
            isLogoPic: true,
            insertSlideArr: [
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: encodeURIComponent(location.href),
                            to: true,
                            kind: 'newsgroup',
                            url: encodeURIComponent(location.href),
                            plat: 'napp',
                        },
                    },
                    downloads,
                    kind: 'share01',
                },
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: encodeURIComponent(location.href),
                            to: true,
                            kind: 'newsgroup',
                            url: encodeURIComponent(location.href),
                            plat: 'napp',
                        },
                    },
                    downloads,
                    kind: 'share01',
                },
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: encodeURIComponent(location.href),
                            to: true,
                            kind: 'newsgroup',
                            url: encodeURIComponent(location.href),
                            plat: 'napp',
                        },
                    },
                    downloads,
                    kind: 'share01',
                },
            ],
        };

        return (
            <section className={styles.bottomSlide}>
                <UpgradeBottomSlides content={slidesConfig} />
            </section>
        );
    }
}

export default errorBoundary(FixBottom);
